module.exports = __webpack_public_path__ + "static/media/choithramsGoogle.bb1bade5.png";